<mat-toolbar color="primary">
  <span id="spørreundersøkelse-opprett-dialog-tittel">
    {{ "Ny spørreundersøkelse"|translate }}
  </span>
  <button mat-icon-button aria-label="Lukk dialog" (click)="avbryt()">
    <mat-icon fontSet="ion-ios-close-empty" class="mat-icon--ionic-ikon"/>
  </button>
</mat-toolbar>

<form [formGroup]="skjema" (ngSubmit)="opprett()">
  <mat-dialog-content #skjemaKontainer>
    <spoerreundersoekelse-skjema [skjemakontroll]="skjema" [tilgjengeligeSkjema]="tilgjengeligeSkjema()"/>
  </mat-dialog-content>
  <mat-dialog-actions align="center">
    <div class="scrollvarsel" [visDersomIkkeScrolletTilBunn]="skjemaKontainer" klasseNaarSynlig="scrollvarsel-synlig"><span>{{ 'Scroll ned for å se resten av skjemaet...' | translate }}</span></div>
    @if (undersoekelseSkjemaKomp().erFoersteSteg()) {
      <button mat-button type="button" (click)="avbryt()">{{ "Avbryt"|translate }}</button>
    } @else {
      <button mat-button type="button" (click)="undersoekelseSkjemaKomp().forrigeSteg()">{{ "Forrige"|translate }}</button>
    }
    @if (undersoekelseSkjemaKomp().erSisteSteg() && skjema.value.aapneForBesvarelse && skjema.value.invitasjon!.sendInvitasjon) {
      <submit-button [arbeidPaagaar]="lagrer()" [skjema]="skjema" spinnerTekst="{{'Oppretter...'|translate}}">{{ 'Opprett spørreundersøkelse og send invitasjon'|translate }}</submit-button>
    } @else if (undersoekelseSkjemaKomp().erSisteSteg())  {
      <submit-button [arbeidPaagaar]="lagrer()" [skjema]="skjema" spinnerTekst="{{'Oppretter...'|translate}}">{{ 'Opprett spørreundersøkelse'|translate }}</submit-button>
    } @else {
      <button mat-flat-button
              color="primary"
              type="button"
              (click)="undersoekelseSkjemaKomp().nesteSteg()"
              [disabled]="!undersoekelseSkjemaKomp().erSkjemaForAktivtStegGyldig()">
        {{ "Neste"|translate }}
      </button>
    }
  </mat-dialog-actions>
</form>
